import { advancedFilters } from './advancedFilters';
import { area } from './area';
import { bedrooms } from './bedrooms';
import { beds } from './beds';
import { dates } from './dates';
import { dealType } from './dealType';
import { geo } from './geo';
import { landArea } from './landArea';
import { offerType } from './offerType';
import { posessor } from './posessor';
import { price } from './price';
import { roomType } from './roomType';
import { IFilter, TFilter } from '../../types/filters';

export const FILTERS: { [key in TFilter]: IFilter } = {
  advancedFilters,
  area,
  bedrooms,
  beds,
  dates,
  dealType,
  geo,
  landArea,
  offerType,
  posessor,
  price,
  roomType,
};
